module.exports = __webpack_public_path__ + "static/media/Lens-Fresh_Blue_HK.3330b947.png";